import { render } from "./AssProfile.vue?vue&type=template&id=123e3be2&scoped=true"
import script from "./AssProfile.vue?vue&type=script&lang=js"
export * from "./AssProfile.vue?vue&type=script&lang=js"

import "./AssProfile.vue?vue&type=style&index=0&id=123e3be2&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123e3be2"]])

export default __exports__